module.exports = __webpack_public_path__ + "../resources/img/maintenance.5cd93fbe.png";